import CreateCampaignFieldMappingRequestModelBase from '../_generated/modelBases/create-campaign-field-mapping-request-model-base';

export default class CreateCampaignFieldMappingRequestModel extends CreateCampaignFieldMappingRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
